import { Component, ElementRef, OnInit } from '@angular/core';
import { AddedToCartDialogComponent } from '@spartacus/cart/base/components';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { RoutingService, TranslatePipe, UrlPipe } from '@spartacus/core';
import { LaunchDialogService, IconComponent, SpinnerComponent } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { EfaCartItemComponent } from '../../../shared/components/efa-cart-item/efa-cart-item.component';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

const LAST_ADDED_CART_ENTRY_INDEX = 0;

@Component({
    selector: 'app-efa-added-to-cart-dialog',
    templateUrl: './efa-added-to-cart-dialog.component.html',
    imports: [IconComponent, EfaCartItemComponent, RouterLink, SpinnerComponent, AsyncPipe, TranslatePipe, UrlPipe]
})
export class EfaAddedToCartDialogComponent extends AddedToCartDialogComponent implements OnInit {

  constructor(
    protected activeCartFacade: ActiveCartFacade,
    protected launchDialogService: LaunchDialogService,
    protected routingService: RoutingService,
    protected el: ElementRef
  ) {
    super(activeCartFacade, launchDialogService, routingService, el);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.entry$ = this.activeCartFacade.getEntries().pipe(map(entries => entries.filter(entry => !entry.subEntry)[LAST_ADDED_CART_ENTRY_INDEX]));
  }
}

